import React, { useEffect, useState, useRef } from 'react'
import './index.less'
import {
  getParamsFromHash
} from '../../../../utils/common'
import { trackGdp } from '../../../../utils/gio-report';

import { getCurrentUid } from '../../../../api/web-h5-common'
import {
  GetMemberGoods
} from '../../api'

// 这个页面需要参数携带图片链接进来展示，定义为imgUrl，传参时需要使用encodeURIComponent进行编码
const App = () => {
  const queryImgUrl = getParamsFromHash('imgUrl')
  const queryTitle = getParamsFromHash('title')
  const imgUrl = queryImgUrl ? decodeURIComponent(queryImgUrl) : ''
  const title = queryTitle ? decodeURIComponent(queryTitle) : ''
  const uid = useRef('')
  const [detailRuleImgUrl, setDetailRuleImgUrl] = useState('')

  useEffect(() => {
    document.title = title || '详细规则'
    trackGdp('P11225', 'B001')

    getMemberGoods()
  }, [])

  const getMemberGoods = async () => {
    try {
      const res: any = await GetMemberGoods()
      if (res.code === 200) {
        setDetailRuleImgUrl(res?.data?.detailRuleImgUrl)
      } else {
        // no need handle
      }
    } catch (error) {
      console.log('getMemberGoods error -->', error)
    }
  }

  // 若url的query参数中有imgUrl，优先使用query参数中的imgUrl
  const imgSrc = imgUrl || detailRuleImgUrl

  return (
    <div className='charge-vip-rules'>
      <div className='content'>
        <img alt='' className='image' src={imgSrc} />
      </div>
    </div>
  )
}

export default App